var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-app',{attrs:{"params":_vm.f7params}},[(!_vm.isLegalDocumentsPublicMode)?_c('ConsentGDPR'):_vm._e(),_vm._v(" "),(_vm.isHashRedirectLoading)?_c('div',{staticClass:"hash-preloader-overlay"},[_c('div',{staticClass:"hash-preloader-card"},[_c('f7-preloader'),_vm._v(" "),_c('div',{staticClass:"hash-preloader-text"},[_vm._v("\n        "+_vm._s(_vm.$t('loading'))+"\n      ")])],1)]):_vm._e(),_vm._v(" "),(
      _vm.isUserLoggedIn &&
      !_vm.isClientMenuReady &&
      !_vm.showTokenPage &&
      !_vm.showPrivacyPolicyPage
    )?_c('div',{staticClass:"session-preloader-overlay"},[_c('div',{staticClass:"hash-preloader-card"},[_c('f7-preloader'),_vm._v(" "),_c('div',{staticClass:"hash-preloader-text"},[_vm._v("\n        "+_vm._s(_vm.$t('loading'))+"\n      ")])],1)]):_vm._e(),_vm._v(" "),(
      _vm.isUserLoggedIn &&
      _vm.isClientMenuReady &&
      !_vm.showTokenPage &&
      !_vm.showPrivacyPolicyPage
    )?_c('FilterPanel'):_vm._e(),_vm._v(" "),(_vm.isFilterPanelOpen)?_c('div',{staticClass:"modal-backdrop",on:{"click":_vm.closeRightPanel}}):_vm._e(),_vm._v(" "),(
      _vm.isUserLoggedIn && !_vm.showTokenPage && !_vm.showPrivacyPolicyPage
    )?_c('Navbar',{attrs:{"socket":_vm.webSocket},on:{"client-menu-ready":_vm.onClientMenuReady}}):_vm._e(),_vm._v(" "),(
      _vm.isUserLoggedIn &&
      _vm.isClientMenuReady &&
      !_vm.showTokenPage &&
      !_vm.showPrivacyPolicyPage
    )?_c('Menu',{attrs:{"menu-config":_vm.topMenuConfig}}):_vm._e(),_vm._v(" "),(
      _vm.showLogin &&
      !_vm.showTokenPage &&
      !_vm.showPrivacyPolicyPage &&
      !_vm.isLegalDocumentsPublicMode
    )?_c('login-page'):_vm._e(),_vm._v(" "),(
      _vm.showPasswordRecovery &&
      !_vm.showTokenPage &&
      !_vm.showPrivacyPolicyPage &&
      !_vm.isLegalDocumentsPublicMode
    )?_c('password-recovery-page'):_vm._e(),_vm._v(" "),(
      _vm.isUserLoggedIn && _vm.isClientMenuReady && !_vm.showPrivacyPolicyPage
    )?_c('f7-view',{staticClass:"safe-areas",attrs:{"main":"","url":"/","reload-pages":true}}):_vm._e(),_vm._v(" "),(
      _vm.showTokenPage &&
      !_vm.showPrivacyPolicyPage &&
      !_vm.isLegalDocumentsPublicMode
    )?_c('TokenRecoveryPage'):_vm._e(),_vm._v(" "),(_vm.showPrivacyPolicyPage)?_c('f7-view',{staticClass:"safe-areas",attrs:{"main":"","url":"/privacy-policy","reload-pages":true}}):_vm._e(),_vm._v(" "),(_vm.isLegalDocumentsPublicMode)?_c('f7-view',{staticClass:"safe-areas legal-documents-public-view",attrs:{"main":"","url":_vm.legalDocumentsPublicUrl,"reload-pages":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }